import styled from 'styled-components'
// views
import { TableFieldWrapper } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableField/views'

export const LinksWrapper = styled.div<{ hasSubParent: boolean }>`
  display: flex;
  flex-direction: column;
  width: ${({ hasSubParent }) => (hasSubParent ? '90' : '100')}% !important;

  * {
    font-size: 14px !important;
  }
`

export const Parent = styled(TableFieldWrapper)`
  gap: 0;

  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    min-width: 20px;
    height: 20px;
    width: 20px;
  }
`
